import { render } from "./nodForm.vue?vue&type=template&id=ae23b08e"
import script from "./nodForm.vue?vue&type=script&lang=js"
export * from "./nodForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__